export default {
  Comites: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "comite"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Comites.js
// module id = 30vf
// module chunks = 16